<accordion [collapsing]="collapsing" [initialOpen]="initialOpen">
    <accordion-item [title]="item.title | translate" [titleKey]="item.title" *ngFor="let item of items; let i = index">
        <ng-template accordionContent>
          <div class="p-4">
            {{item.answer | translate}}
          </div>
        </ng-template> 
    </accordion-item>
</accordion>
